import React, { useRef, useEffect } from 'react'
// import { ImQrcode } from "react-icons/im";
import { ReactComponent as ImQrcode } from "../../../Assets/img/icons/QrCode_AllCards.svg";
import { ReactComponent as IoMdShare } from "../../../Assets/img/icons/Share.svg";
// import { IoMdShare } from "react-icons/io";
import CardWaveStd from '../../Utilities/CardWaveStd';
import CardWaveSmile from '../../Utilities/CardWaveSmile2'
import CardWaveFlat from '../../Utilities/CardWaveFlat';
import CardWaveSlope from '../../Utilities/CardWaveSlope2';
import DefaultProfileBg from "../../../Assets/img/card/profilebg.png"
import { ReactComponent as CAIndialogo } from '../../../Assets/img/icons/ca-india-logo.svg'
// import HrOuterShape1 from '../../../Assets/img/card/hr-outer-shape-above.svg'
// import HrOuterShape2 from '../../../Assets/img/card/hr-outer-shape-below.svg'
// import HrInnerShape from '../../Utilities/HrInnerShape';
import HrInnerShape from '../../../Assets/img/card/hr-inner-shape.svg'
import HrOuterShape1 from '../../Utilities/HrOuterShape1';
import { ReactComponent as ITGridShape1 } from '../../../Assets/img/card/it-layout-shape-1.svg'
import { ReactComponent as ITGridShape2 } from '../../../Assets/img/card/it-layout-shape-2.svg'
import { ReactComponent as ITGridShape3 } from '../../../Assets/img/card/it-layout-shape-3.svg'
import { ReactComponent as ITGridShape4 } from '../../../Assets/img/card/it-layout-shape-4.svg'
import { ReactComponent as ITGridShape5 } from '../../../Assets/img/card/it-layout-shape-5.svg'
import { ReactComponent as BottomLight } from '../../../Assets/img/card/adv-layout-bottom-light.svg'
import { ReactComponent as TopLight } from '../../../Assets/img/card/adv-layout-top-light.svg'
import { ReactComponent as BottomBold } from '../../../Assets/img/card/adv-layout-bottom-bold.svg'
import { ReactComponent as TopBold } from '../../../Assets/img/card/adv-layout-top-bold.svg'
import QrCodeCard from './QrCodeCard';
// import { ReactComponent as VerifiedTick } from "../../../Assets/img/icons/verified-tick.svg";
import { ReactComponent as NonVerifiedTickNew } from "../../../Assets/img/icons/Non-verified-icon.svg";
import { ReactComponent as VerifiedTickN } from "../../../Assets/img/icons/Verified-icon-new.svg";
import PhoneIphoneRoundedIcon from '@mui/icons-material/PhoneIphoneRounded';
import CallRoundedIcon from '@mui/icons-material/CallRounded';
// import MailRoundedIcon from '@mui/icons-material/MailRounded';
import PublicIcon from '@mui/icons-material/Public';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import { EmailRounded } from '@material-ui/icons';
import { Box } from "@mui/material";
import { Link } from 'react-router-dom';
import { useUserDetailContext } from '../../UserDetailContext';
import ShareQR from './ShareQR';
import { FaStar } from 'react-icons/fa';
import { MdOutlinePhoneIphone } from "react-icons/md";
import SmsIcon from '@mui/icons-material/Sms';
import EmailIcon from '@mui/icons-material/Email';
import { ReactComponent as WhatsAppFilled } from "../../../Assets/img/icons/whatsapp-filled.svg"
import QrCodeDialog from './QrCodeDialog';
import { ReactComponent as FavIcon } from "../../../Assets/img/icons/Favourites Icons.svg"

// Non-personal Layouts : 1, 3, 5, 7 - Applicable to Professional, Student, and GenZ Cards

const Layout1 = ({ layoutProps, favoriteCards, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, firstName, lastName, suffix,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, isVerified,

        quantity, CardStylesofCard, sharePops, cardDetailsofCard, handleFavoriteClick,
        ContactStylesofCard, userDetails, dialogs, handleCloseDialog, handleShareClose, getFontWeight,
        handleOpenDialog, handleShareClick, contactDetails, is_student_verified } = layoutProps;

    return (
        <>
            <div className={`item-card-display digi-card-new  ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ fontStyle: CardStylesofCard ? CardStylesofCard?.style : "Lato", fontFamily: CardStylesofCard ? CardStylesofCard?.font : "Lato", fontWeight: getFontWeight(CardStylesofCard?.style), fontSize: CardStylesofCard ? CardStylesofCard?.size : '', color: CardStylesofCard ? CardStylesofCard?.colorSecondary : '', backgroundColor: CardStylesofCard?.bgColor || '' }}>
                <Box className="preview-card all-cards">
                    <div id='Card-firstPart-createNew'>
                        <Link to={`/card/${card}`}>
                            <>
                                <div className={`preview-card-upper ${quantity === 1 ? "Smaller-screen" : ""}`}
                                    style={{
                                        backgroundImage: `url(${profilePicture})`,
                                        backgroundSize: "cover", backgroundPosition: "center"
                                    }}>
                                    <div className="favorite-icon icon flex-center" onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleFavoriteClick(card);
                                    }}>
                                        {favoriteCards.includes(card) ? <FaStar color={"#FCB809"} /> : <FavIcon />}
                                    </div>
                                    <div className={`digi-card-label-container truncate ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                        <span className='digi-card-label'>{card}</span>
                                    </div>
                                    <div>
                                        <div>
                                            <CardWaveStd bgColor={CardStylesofCard?.bgColor || "#ffff"} strokeColor={CardStylesofCard?.colorLayout || "#0044c6"} />
                                            <div className={`company-logo-container-cardSection flex-center ${quantity === 1 ? "Smaller-screen" : ""}`}>
                                                <img className='contain-image' src={companyLogo} alt="companylogo" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={`preview-card-names ${quantity === 1 ? "Smaller-screen" : ""}`}>
                                    {userDetails?.name && userDetails?.name?.length <= 20 ? (
                                        <h3 className='truncate' style={{ color: CardStylesofCard ? CardStylesofCard.colorPrimary : "black" }}>{userDetails.name}</h3>
                                    ) : (
                                        <div className="d-flex align-items-center">
                                            <h3 className={`long-name truncate`} style={{ color: CardStylesofCard ? CardStylesofCard.colorPrimary : "black" }} title={userDetails.name}>
                                                {userDetails.name}
                                            </h3>
                                        </div>
                                    )}
                                    <h5 className='truncate' style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}>
                                        {cardType === "Professional" || cardType === "Customize_Professional"
                                            ? (companyName ? `${companyName} - ${designation}` : designation)
                                            : title}
                                    </h5>
                                </div>
                            </>
                        </Link>

                        {cardDetailsofCard?.is_experience_current === true && (CardStylesofCard?.CardType === 'Professional' || CardStylesofCard?.CardType === "Customize_Professional") ? <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} /> : ""}

                        {(CardStylesofCard?.CardType === "Student" || CardStylesofCard?.CardType === "Customize_Student" || CardStylesofCard?.CardType === "Personal" || CardStylesofCard?.CardType === "Customize_Personal") && <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} />}
                    </div>

                    {/* <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} />
                     */}

                    {cardDetailsofCard?.is_experience_current === true && (CardStylesofCard?.CardType === 'Professional' || CardStylesofCard?.CardType === "Customize_Professional") ? <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} /> : ""}

                    {(CardStylesofCard?.CardType === "Student" || CardStylesofCard?.CardType === "Customize_Student" || CardStylesofCard?.CardType === "Personal" || CardStylesofCard?.CardType === "Customize_Personal") && <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} />}

                    {quantity !== 1 && (
                        <div className="mt-2 line-card place-at-bottom">
                            <div className="line-blue" style={{ backgroundColor: CardStylesofCard?.colorLayout }}></div>
                            <div className="icons_share_qr icon-alignment-card d-flex align-items-center justify-content-center">
                                <div className='icon-border me-3 flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    <ImQrcode className='icon-color' onClick={() => handleOpenDialog(card)} />
                                </div>
                                <div className='icon-border icon-verify-symbol me-3 flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    {isVerified === true || is_student_verified === true ? <VerifiedTickN title="Verified" /> : <NonVerifiedTickNew title="Not Verified" />}
                                </div>
                                <div className='icon-border flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    <IoMdShare className='icon-color' onClick={() => handleShareClick(card)} />
                                </div>
                            </div>
                        </div>
                    )}
                    {quantity !== 1 && (
                        contactDetails !== undefined ? (<>
                            <div className='quick-link-containerNew'>
                                {contactDetails?.call_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <MdOutlinePhoneIphone className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>Call</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.sms_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <SmsIcon className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>SMS</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.email_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <EmailIcon className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>E-mail</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.whatsapp_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <WhatsAppFilled className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>WhatsApp</div>
                                        </a>
                                    </div>
                                )}
                            </div></>) : (<>
                                <div className='quick-link-containerNew'>
                                    {ContactStylesofCard?.callNo?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <MdOutlinePhoneIphone className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>Call</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.textNo?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <SmsIcon className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>SMS</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.emailId?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <EmailIcon className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>E-mail</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.whatsapp?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <WhatsAppFilled className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>WhatsApp</div>
                                            </a>
                                        </div>
                                    )}
                                </div></>)

                    )}
                </Box>

            </div>
        </>
    )
}

const Layout3 = ({ layoutProps, favoriteCards, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, firstName, lastName, suffix,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, isVerified, is_student_verified,

        quantity, CardStylesofCard, sharePops, cardDetailsofCard, handleFavoriteClick,
        ContactStylesofCard, userDetails, dialogs, handleCloseDialog, handleShareClose, getFontWeight,
        handleOpenDialog, handleShareClick, contactDetails } = layoutProps;

    return (
        <>
            <div className={`item-card-display digi-card-new  ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ fontStyle: CardStylesofCard ? CardStylesofCard?.style : "Lato", fontFamily: CardStylesofCard ? CardStylesofCard?.font : "Lato", fontWeight: getFontWeight(CardStylesofCard?.style), fontSize: CardStylesofCard ? CardStylesofCard.size : '', color: CardStylesofCard ? CardStylesofCard.colorSecondary : '', backgroundColor: CardStylesofCard?.bgColor || '' }}>
                <Box className="preview-card all-cards">
                    <div id='Card-firstPart-createNew'>
                        <Link to={`/card/${card}`}>
                            <div className={`preview-card-upper previewcardupper LargerScreen full-bg-cover ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ backgroundImage: `url(${profilePicture})` }}>
                                <div className="favorite-icon icon flex-center" onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleFavoriteClick(card);
                                }}>
                                    {favoriteCards.includes(card) ?
                                        <FaStar color={"#FCB809"} /> : <FavIcon />
                                    }
                                </div>
                                <div className={`digi-card-label-container truncate ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ backgroundColor: layoutColor }}>
                                    <span className='digi-card-label' style={{ color: labelColor }}> {card}</span>
                                </div>
                                <div>
                                    <div>
                                        <CardWaveFlat bgColor={bgColor} strokeColor={layoutColor} />
                                    </div>
                                </div>

                                {cardType != "Personal" &&
                                    <>
                                        {(companyLogo && companyLogo.length !== 0) ? (
                                            <div className={`company-logo-container layout-3 new flex-center ${quantity === 1 ? "Smaller-screen" : ""}`}>
                                                <img className='contain-image' src={companyLogo} alt="companylogo" />
                                            </div>
                                        ) : (
                                            <div className={`company-logo-container flex-center ${quantity === 1 ? "Smaller-screen" : ""}`}>
                                                <img src={DefaultProfileBg} alt='Logo' className='contain-image' />
                                            </div>
                                        )}
                                    </>}

                            </div>
                            <div className={`preview-card-names ${quantity === 1 ? "mt-3 Smaller-screen" : ""}`} style={{ marginTop: "30px" }}>
                                <h3 className='d-flex truncate' style={{ color: colorPrimary ?? "black" }} title={userDetails.name}>{userDetails.name}</h3>
                                <h5 className='truncate' style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}>
                                    {cardType === "Professional" || cardType === "Customize_Professional"
                                        ? (companyName ? `${companyName} - ${designation}` : designation)
                                        : title}
                                </h5>
                            </div>
                        </Link>
                        {/* <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} /> */}

                        {cardDetailsofCard?.is_experience_current === true && (CardStylesofCard?.CardType === 'Professional' || CardStylesofCard?.CardType === "Customize_Professional") ? <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} /> : ""}

                        {(CardStylesofCard?.CardType === "Student" || CardStylesofCard?.CardType === "Customize_Student" || CardStylesofCard?.CardType === "Personal" || CardStylesofCard?.CardType === "Customize_Personal") && <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} />}
                    </div>

                    {/* <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} /> */}

                    {cardDetailsofCard?.is_experience_current === true && (CardStylesofCard?.CardType === 'Professional' || CardStylesofCard?.CardType === "Customize_Professional") ? <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} /> : ""}

                    {(CardStylesofCard?.CardType === "Student" || CardStylesofCard?.CardType === "Customize_Student" || CardStylesofCard?.CardType === "Personal" || CardStylesofCard?.CardType === "Customize_Personal") && <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} />}
                    {quantity !== 1 && (
                        <div className="mt-2 line-card place-at-bottom">
                            <div className="line-blue" style={{ backgroundColor: CardStylesofCard?.colorLayout }}></div>
                            <div className="icons_share_qr icon-alignment-card d-flex align-items-center justify-content-center">
                                <div className='icon-border me-3 flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    <ImQrcode className='icon-color' onClick={() => handleOpenDialog(card)} />
                                </div>
                                <div className='icon-border icon-verify-symbol me-3 flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    {/* {isVerified === true ? <VerifiedTickN /> : <NonVerifiedTickNew />} */}
                                    {isVerified === true || is_student_verified === true ?
                                        <VerifiedTickN title="Verified" /> :
                                        <NonVerifiedTickNew title="Not Verified" />
                                    }
                                </div>
                                <div className='icon-border flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    <IoMdShare className='icon-color' onClick={() => handleShareClick(card)} />
                                </div>
                            </div>
                        </div>
                    )}
                    {/* {quantity !== 1 && (
                        <div className='quick-link-containerNew'>
                            {ContactStylesofCard?.callNo?.visible && (
                                <div className='flex-center flex-column quick-link-icon'> */}
                    {/* {console.log("ContactStyles.callNo.input : ", ContactStylesForPersonal.callNo.input)} */}
                    {/* <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'>
                                        <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}><MdOutlinePhoneIphone className='icon-color3' /></div>
                                        <div className='contact-label'>Call</div>
                                    </a>
                                </div>)}
                            {ContactStylesofCard?.textNo?.visible && (
                                <div className='flex-center flex-column quick-link-icon'>
                                    <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'>
                                        <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}><SmsIcon className='icon-color3' /></div>
                                        <div className='contact-label'>SMS</div>
                                    </a>
                                </div>)}
                            {ContactStylesofCard?.emailId?.visible && (
                                <div className='flex-center flex-column quick-link-icon'>
                                    <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'>
                                        <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}><EmailIcon className='icon-color3' /></div>
                                        <div className='contact-label'>E-mail</div>
                                    </a>
                                </div>)}
                            {ContactStylesofCard?.whatsapp?.visible && (
                                <div className='flex-center flex-column quick-link-icon'>
                                    <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'>
                                        <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}><WhatsAppFilled className='icon-color3' /></div>
                                        <div className='contact-label'>WhatsApp</div>
                                    </a>
                                </div>)}
                        </div>
                    )} */}



                    {quantity !== 1 && (
                        contactDetails !== undefined ? (<>
                            <div className='quick-link-containerNew'>
                                {contactDetails?.call_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <MdOutlinePhoneIphone className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>Call</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.sms_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <SmsIcon className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>SMS</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.email_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <EmailIcon className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>E-mail</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.whatsapp_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <WhatsAppFilled className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>WhatsApp</div>
                                        </a>
                                    </div>
                                )}
                            </div></>) : (<>
                                <div className='quick-link-containerNew'>
                                    {ContactStylesofCard?.callNo?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <MdOutlinePhoneIphone className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>Call</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.textNo?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <SmsIcon className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>SMS</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.emailId?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <EmailIcon className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>E-mail</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.whatsapp?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <WhatsAppFilled className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>WhatsApp</div>
                                            </a>
                                        </div>
                                    )}
                                </div></>)

                    )}
                </Box>
            </div>
        </>
    )
}

const Layout5 = ({ layoutProps, favoriteCards, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, firstName, lastName, suffix,
        companyName, designation, title, colorPrimary,
        colorSecondary, layoutColor, labelColor, isVerified, is_student_verified,

        quantity, CardStylesofCard, sharePops, cardDetailsofCard, handleFavoriteClick,
        ContactStylesofCard, userDetails, dialogs, handleCloseDialog, handleShareClose, getFontWeight,
        handleOpenDialog, handleShareClick, contactDetails } = layoutProps;

    return (
        <>
            <div className={`item-card-display digi-card-new  ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ fontStyle: CardStylesofCard ? CardStylesofCard?.style : "Lato", fontFamily: CardStylesofCard ? CardStylesofCard?.font : "Lato", fontWeight: getFontWeight(CardStylesofCard?.style), fontSize: CardStylesofCard ? CardStylesofCard.size : '', color: CardStylesofCard ? CardStylesofCard.colorSecondary : '', backgroundColor: CardStylesofCard?.bgColor || '' }}>
                <Box className="preview-card all-cards">
                    <div id='Card-firstPart-createNew'>
                        <Link to={`/card/${card}`}>

                            <div className={`preview-card-upper previewcardupper layout-5New ${quantity === 1 ? "Smaller-screen" : ""}`}>
                                <div className="favorite-icon icon flex-center" onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleFavoriteClick(card);
                                }}>
                                    {favoriteCards.includes(card) ?
                                        <FaStar color={"#FCB809"} /> : <FavIcon />
                                    }
                                </div>
                                <div className={`digi-card-label-container truncate ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ backgroundColor: layoutColor }}>
                                    <span className='digi-card-label' style={{ color: labelColor }}> {card}</span>
                                </div>
                                <div className='layout-5-img-container'>
                                    <div className='layout-images-wrapper'>
                                        <img className={`layout-profile-picture mt-0 ${quantity === 1 ? "Smaller-screen" : ""}`} src={profilePicture} alt="Profile" />
                                        <div className={`layout-logo-container flex-center ${quantity === 1 ? "Smaller-screen" : ""}`} >
                                            <img src={companyLogo} alt="Logo" />
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className={`preview-card-names ${quantity === 1 ? " Smaller-screen" : ""}`}>
                                <h3 className='d-flex truncate' style={{ color: colorPrimary ?? "black" }} title={userDetails.name}>{userDetails.name}</h3>
                                <h5 className='truncate' style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}>
                                    {cardType === "Professional" || cardType === "Customize_Professional"
                                        ? (companyName ? `${companyName} - ${designation}` : designation)
                                        : title}
                                </h5>
                            </div>
                        </Link>
                        {/* <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} /> */}
                        {cardDetailsofCard?.is_experience_current === true && (CardStylesofCard?.CardType === 'Professional' || CardStylesofCard?.CardType === "Customize_Professional") ? <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} /> : ""}

                        {(CardStylesofCard?.CardType === "Student" || CardStylesofCard?.CardType === "Customize_Student" || CardStylesofCard?.CardType === "Personal" || CardStylesofCard?.CardType === "Customize_Personal") && <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} />}
                    </div>

                    {/* <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} /> */}

                    {cardDetailsofCard?.is_experience_current === true && (CardStylesofCard?.CardType === 'Professional' || CardStylesofCard?.CardType === "Customize_Professional") ? <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} /> : ""}

                    {(CardStylesofCard?.CardType === "Student" || CardStylesofCard?.CardType === "Customize_Student" || CardStylesofCard?.CardType === "Personal" || CardStylesofCard?.CardType === "Customize_Personal") && <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} />}
                    {quantity !== 1 && (
                        <div className="mt-2 line-card place-at-bottom">
                            <div className="line-blue" style={{ backgroundColor: CardStylesofCard?.colorLayout }}></div>
                            <div className="icons_share_qr icon-alignment-card d-flex align-items-center justify-content-center">
                                <div className='icon-border me-3 flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    <ImQrcode className='icon-color' onClick={() => handleOpenDialog(card)} />
                                </div>
                                <div className='icon-border icon-verify-symbol me-3 flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    {/* {isVerified === true ? <VerifiedTickN /> : <NonVerifiedTickNew />} */}
                                    {isVerified === true || is_student_verified === true ?
                                        <VerifiedTickN title="Verified" /> :
                                        <NonVerifiedTickNew title="Not Verified" />
                                    }
                                </div>
                                <div className='icon-border flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    <IoMdShare className='icon-color' onClick={() => handleShareClick(card)} />
                                </div>
                            </div>
                        </div>
                    )}
                    {/* {quantity !== 1 && (
                        <div className='quick-link-containerNew'>
                            {ContactStylesofCard?.callNo?.visible && (
                                <div className='flex-center flex-column quick-link-icon'> */}
                    {/* {console.log("ContactStyles.callNo.input : ", ContactStylesForPersonal.callNo.input)} */}
                    {/* <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'>
                                        <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}><MdOutlinePhoneIphone className='icon-color3' /></div>
                                        <div className='contact-label'>Call</div>
                                    </a>
                                </div>)}
                            {ContactStylesofCard?.textNo?.visible && (
                                <div className='flex-center flex-column quick-link-icon'>
                                    <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'>
                                        <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}><SmsIcon className='icon-color3' /></div>
                                        <div className='contact-label'>SMS</div>
                                    </a>
                                </div>)}
                            {ContactStylesofCard?.emailId?.visible && (
                                <div className='flex-center flex-column quick-link-icon'>
                                    <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'>
                                        <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}><EmailIcon className='icon-color3' /></div>
                                        <div className='contact-label'>E-mail</div>
                                    </a>
                                </div>)}
                            {ContactStylesofCard?.whatsapp?.visible && (
                                <div className='flex-center flex-column quick-link-icon'>
                                    <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'>
                                        <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}><WhatsAppFilled className='icon-color3' /></div>
                                        <div className='contact-label'>WhatsApp</div>
                                    </a>
                                </div>)}
                        </div>)} */}


                    {quantity !== 1 && (
                        contactDetails !== undefined ? (<>
                            <div className='quick-link-containerNew'>
                                {contactDetails?.call_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <MdOutlinePhoneIphone className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>Call</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.sms_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <SmsIcon className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>SMS</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.email_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <EmailIcon className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>E-mail</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.whatsapp_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <WhatsAppFilled className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>WhatsApp</div>
                                        </a>
                                    </div>
                                )}
                            </div></>) : (<>
                                <div className='quick-link-containerNew'>
                                    {ContactStylesofCard?.callNo?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <MdOutlinePhoneIphone className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>Call</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.textNo?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <SmsIcon className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>SMS</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.emailId?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <EmailIcon className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>E-mail</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.whatsapp?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <WhatsAppFilled className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>WhatsApp</div>
                                            </a>
                                        </div>
                                    )}
                                </div></>)

                    )}
                </Box>
            </div>
        </>
    )
}

const Layout7 = ({ layoutProps, favoriteCards, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, firstName, lastName, suffix,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, isVerified, is_student_verified,

        quantity, CardStylesofCard, sharePops, cardDetailsofCard, handleFavoriteClick,
        ContactStylesofCard, userDetails, dialogs, handleCloseDialog, handleShareClose, getFontWeight,
        handleOpenDialog, handleShareClick, contactDetails } = layoutProps;

    return (
        <>
            <div className={`item-card-display digi-card-new  ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ fontStyle: CardStylesofCard ? CardStylesofCard?.style : "Lato", fontFamily: CardStylesofCard ? CardStylesofCard?.font : "Lato", fontWeight: getFontWeight(CardStylesofCard?.style), fontSize: CardStylesofCard ? CardStylesofCard.size : '', color: CardStylesofCard ? CardStylesofCard.colorSecondary : '', backgroundColor: CardStylesofCard?.bgColor || '' }}>
                <Box className="preview-card all-cards">
                    <div id='Card-firstPart-createNew'>
                        <Link to={`/card/${card}`}>
                            <div className={`preview-card-upper previewcardupper layout-7 full-bg-cover ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ backgroundImage: `url(${profilePicture})` }}>

                                <div className="favorite-icon icon flex-center" onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleFavoriteClick(card);
                                }}>
                                    {favoriteCards.includes(card) ?
                                        <FaStar color={"#FCB809"} /> : <FavIcon />
                                    }
                                </div>
                                <div className={`digi-card-label-container truncate ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ backgroundColor: layoutColor }}>
                                    <span className='digi-card-label' style={{ color: labelColor }}> {card}</span>
                                </div>
                                <div>
                                    <div>
                                        <CardWaveSlope bgColor={bgColor} strokeColor={layoutColor} />
                                    </div>

                                    {cardType !== "Personal" &&
                                        <>
                                            {(companyLogo && companyLogo.length !== 0) ? (
                                                <div className={`company-logo-container layout-7 new flex-center ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ bottom: "1rem" }}>
                                                    <img src={companyLogo} alt='Logo' style={{ objectPosition: "center" }} />
                                                </div>
                                            ) : (
                                                <div className='company-logo-container flex-center'>
                                                    <img src={DefaultProfileBg} className='default-logo-min-size' alt='empty' />
                                                </div>
                                            )}
                                        </>}
                                </div>

                            </div>
                            <div className={`preview-card-names ${quantity === 1 ? "Smaller-screen" : ""}`}>
                                <h3 className='d-flex truncate' style={{ color: colorPrimary ?? "black" }} title={userDetails.name}>{userDetails.name}</h3>
                                <h5 className='truncate' style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}>
                                    {cardType === "Professional" || cardType === "Customize_Professional"
                                        ? (companyName ? `${companyName} - ${designation}` : designation)
                                        : title}
                                </h5>                            </div>
                        </Link>
                        {/* <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} /> */}
                        {cardDetailsofCard?.is_experience_current === true && (CardStylesofCard?.CardType === 'Professional' || CardStylesofCard?.CardType === "Customize_Professional") ? <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} /> : ""}

                        {(CardStylesofCard?.CardType === "Student" || CardStylesofCard?.CardType === "Customize_Student" || CardStylesofCard?.CardType === "Personal" || CardStylesofCard?.CardType === "Customize_Personal") && <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} />}
                    </div>

                    {/* <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} /> */}

                    {cardDetailsofCard?.is_experience_current === true && (CardStylesofCard?.CardType === 'Professional' || CardStylesofCard?.CardType === "Customize_Professional") ? <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} /> : ""}

                    {(CardStylesofCard?.CardType === "Student" || CardStylesofCard?.CardType === "Customize_Student" || CardStylesofCard?.CardType === "Personal" || CardStylesofCard?.CardType === "Customize_Personal") && <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} />}
                    {quantity !== 1 && (
                        <div className="mt-2 line-card place-at-bottom">
                            <div className="line-blue" style={{ backgroundColor: CardStylesofCard?.colorLayout }}></div>
                            <div className="icons_share_qr icon-alignment-card d-flex align-items-center justify-content-center">
                                <div className='icon-border me-3 flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    <ImQrcode className='icon-color' onClick={() => handleOpenDialog(card)} />
                                </div>
                                <div className='icon-border icon-verify-symbol me-3 flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    {/* {isVerified === true ? <VerifiedTickN /> : <NonVerifiedTickNew />} */}
                                    {isVerified === true || is_student_verified === true ?
                                        <VerifiedTickN title="Verified" /> :
                                        <NonVerifiedTickNew title="Not Verified" />
                                    }
                                </div>
                                <div className='icon-border flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    <IoMdShare className='icon-color' onClick={() => handleShareClick(card)} />
                                </div>
                            </div>
                        </div>
                    )}
                    {/* {quantity !== 1 && (
                        <div className='quick-link-containerNew'>
                            {ContactStylesofCard?.callNo?.visible && (
                                <div className='flex-center flex-column quick-link-icon'> */}
                    {/* {console.log("ContactStyles.callNo.input : ", ContactStylesForPersonal.callNo.input)} */}
                    {/* <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'>
                                        <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}><MdOutlinePhoneIphone className='icon-color3' /></div>
                                        <div className='contact-label'>Call</div>
                                    </a>
                                </div>)}
                            {ContactStylesofCard?.textNo?.visible && (
                                <div className='flex-center flex-column quick-link-icon'>
                                    <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'>
                                        <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}><SmsIcon className='icon-color3' /></div>
                                        <div className='contact-label'>SMS</div>
                                    </a>
                                </div>)}
                            {ContactStylesofCard?.emailId?.visible && (
                                <div className='flex-center flex-column quick-link-icon'>
                                    <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'>
                                        <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}><EmailIcon className='icon-color3' /></div>
                                        <div className='contact-label'>E-mail</div>
                                    </a>
                                </div>)}
                            {ContactStylesofCard?.whatsapp?.visible && (
                                <div className='flex-center flex-column quick-link-icon'>
                                    <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'>
                                        <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}><WhatsAppFilled className='icon-color3' /></div>
                                        <div className='contact-label'>WhatsApp</div>
                                    </a>
                                </div>)}
                        </div>
                    )} */}

                    {quantity !== 1 && (
                        contactDetails !== undefined ? (<>
                            <div className='quick-link-containerNew'>
                                {contactDetails?.call_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <MdOutlinePhoneIphone className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>Call</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.sms_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <SmsIcon className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>SMS</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.email_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <EmailIcon className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>E-mail</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.whatsapp_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <WhatsAppFilled className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>WhatsApp</div>
                                        </a>
                                    </div>
                                )}
                            </div></>) : (<>
                                <div className='quick-link-containerNew'>
                                    {ContactStylesofCard?.callNo?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <MdOutlinePhoneIphone className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>Call</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.textNo?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <SmsIcon className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>SMS</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.emailId?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <EmailIcon className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>E-mail</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.whatsapp?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <WhatsAppFilled className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>WhatsApp</div>
                                            </a>
                                        </div>
                                    )}
                                </div></>)

                    )}
                </Box>
            </div>
        </>
    )
}

// Personal Layouts : 2, 4, 6, 8
const Layout2 = ({ layoutProps, favoriteCards, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, firstName, lastName, suffix,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, handleOpenDialog, handleShareClick, isVerified, is_student_verified,

        quantity, CardStylesofCard, sharePops, cardDetailsofCard, handleFavoriteClick,
        ContactStylesofCard, userDetails, dialogs, handleCloseDialog, handleShareClose, getFontWeight, contactDetails } = layoutProps;

    return (
        <>
            <div className={`item-card-display digi-card-new  ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ fontStyle: CardStylesofCard ? CardStylesofCard?.style : "Lato", fontFamily: CardStylesofCard ? CardStylesofCard?.font : "Lato", fontWeight: getFontWeight(CardStylesofCard?.style), fontSize: CardStylesofCard ? CardStylesofCard.size : '', color: CardStylesofCard ? CardStylesofCard.colorSecondary : '', backgroundColor: bgColor }}>
                <Box className="preview-card all-cards">
                    <div id='Card-firstPart-createNew'>
                        <Link to={`/card/${card}`}>
                            <div className={`preview-card-upper ${quantity === 1 ? "Smaller-screen" : ""}`}
                                style={{
                                    backgroundImage: `url(${profilePicture})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center"
                                }}>
                                <div className="favorite-icon icon flex-center" onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleFavoriteClick(card);
                                }}>
                                    {favoriteCards.includes(card) ?
                                        <FaStar color={"#FCB809"} /> : <FavIcon />
                                    }
                                </div>
                                <div className={`digi-card-label-container truncate ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                    <span className='digi-card-label'>{card}</span>
                                </div>
                                <div>
                                    <div>
                                        <CardWaveSmile bgColor={bgColor || "#ffff"} strokeColor={CardStylesofCard?.colorLayout || "#0044c6"} />
                                        {quantity !== 1 && (
                                            <>
                                                <div className="icons_share_qr icon-alignment-card smile-share-icons d-flex align-items-center justify-content-center">
                                                    <div className='icon-border me-3 flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                                        <ImQrcode className='icon-color' onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation(); handleOpenDialog(card)
                                                        }} />
                                                    </div>
                                                    <div className='icon-border icon-verify-symbol me-3 flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                                        {/* {isVerified === true ? <VerifiedTickN /> : <NonVerifiedTickNew />} */}
                                                        {isVerified === true || is_student_verified === true ?
                                                            <VerifiedTickN title="Verified" /> :
                                                            <NonVerifiedTickNew title="Not Verified" />
                                                        }
                                                    </div>
                                                    <div className='icon-border flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                                        <IoMdShare className='icon-color' onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation(); handleShareClick(card)
                                                        }} />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={`preview-card-names text-center ${quantity === 1 ? "Smaller-screen" : ""}`}>
                                {
                                    userDetails?.name && userDetails?.name.length <= 25 ? (
                                        <h3 className='truncate' style={{ color: CardStylesofCard ? CardStylesofCard.colorPrimary : "black" }} title={userDetails.name}>{userDetails.name}</h3>
                                    ) : (
                                        <h3 className='truncate' style={{ color: CardStylesofCard ? CardStylesofCard.colorPrimary : "black" }} title={userDetails.name}>{userDetails.name}</h3>
                                    )
                                }
                                {cardDetailsofCard?.title && cardDetailsofCard?.title.length !== 0 ? (
                                    <h5 className='m-0 truncate' style={{ color: CardStylesofCard ? CardStylesofCard.colorSecondary : "black" }}>{cardDetailsofCard.title}</h5>
                                ) : (
                                    <></>
                                )
                                }
                            </div>
                        </Link>

                        {quantity !== 1 && (<>
                            {cardDetailsofCard?.summary?.length > 82 ? (
                                <div className='summary-container'>
                                    {cardDetailsofCard?.summary?.slice(0, 82) + "..."}
                                </div>
                            ) : (
                                <div className='summary-container small-summary'>
                                    {cardDetailsofCard?.summary}
                                </div>
                            )}
                        </>)
                        }

                        {/* <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} /> */}

                        {cardDetailsofCard?.is_experience_current === true && (CardStylesofCard?.CardType === 'Professional' || CardStylesofCard?.CardType === "Customize_Professional") ? <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} /> : ""}

                        {(CardStylesofCard?.CardType === "Student" || CardStylesofCard?.CardType === "Customize_Student" || CardStylesofCard?.CardType === "Personal" || CardStylesofCard?.CardType === "Customize_Personal") && <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} />}
                    </div>

                    {/* <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} /> */}
                    {cardDetailsofCard?.is_experience_current === true && (CardStylesofCard?.CardType === 'Professional' || CardStylesofCard?.CardType === "Customize_Professional") ? <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} /> : ""}

                    {(CardStylesofCard?.CardType === "Student" || CardStylesofCard?.CardType === "Customize_Student" || CardStylesofCard?.CardType === "Personal" || CardStylesofCard?.CardType === "Customize_Personal") && <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} />}

                    {/* {quantity !== 1 && (
                        <>
                            <div className='personal-card-line' />
                            <div className='quick-link-containerNew'>
                                {ContactStylesofCard?.callNo?.visible && (
                                    <div className='flex-center flex-column quick-link-icon'> */}
                    {/* {console.log("ContactStyles.callNo.input : ", ContactStylesofCard.callNo.input)} */}
                    {/* <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'> */}
                    {/* <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}><MdOutlinePhoneIphone className='icon-color3' /></div>
                                        <div className='contact-label'>Call</div> */}
                    {/* </a> */}
                    {/* </div>)}
                                {ContactStylesofCard?.textNo?.visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        {/* <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'> */}
                    {/* <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}><SmsIcon className='icon-color3' /></div>
                    <div className='contact-label'>SMS</div> */}
                    {/* </a> */}
                    {/* </div>)}
                                {ContactStylesofCard?.emailId?.visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        {/* <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'> */}
                    {/* <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}><EmailIcon className='icon-color3' /></div>
                    <div className='contact-label'>E-mail</div> */}
                    {/* </a> */}
                    {/* </div>)}
                                {ContactStylesofCard?.whatsapp?.visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        {/* <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'> */}
                    {/* <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}><WhatsAppFilled className='icon-color3' /></div>
                    <div className='contact-label'>WhatsApp</div> */}
                    {/* </a> */}
                    {/* </div>)}
                            </div>
                        </>
                    )}  */}


                    {quantity !== 1 && (
                        contactDetails !== undefined ? (<>
                            <div className='quick-link-containerNew'>
                                {contactDetails?.call_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <MdOutlinePhoneIphone className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>Call</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.sms_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <SmsIcon className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>SMS</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.email_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <EmailIcon className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>E-mail</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.whatsapp_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <WhatsAppFilled className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>WhatsApp</div>
                                        </a>
                                    </div>
                                )}
                            </div></>) : (<>
                                <div className='quick-link-containerNew'>
                                    {ContactStylesofCard?.callNo?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <MdOutlinePhoneIphone className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>Call</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.textNo?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <SmsIcon className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>SMS</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.emailId?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <EmailIcon className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>E-mail</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.whatsapp?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <WhatsAppFilled className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>WhatsApp</div>
                                            </a>
                                        </div>
                                    )}
                                </div></>)

                    )}

                </Box>
            </div>
        </>
    )
}

const Layout4 = ({ layoutProps, favoriteCards, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, firstName, lastName, suffix,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, handleOpenDialog, handleShareClick, isVerified, is_student_verified,

        quantity, CardStylesofCard, sharePops, cardDetailsofCard, handleFavoriteClick,
        ContactStylesofCard, userDetails, dialogs, handleCloseDialog, handleShareClose, getFontWeight, contactDetails } = layoutProps;

    return (
        <>
            <div className={`item-card-display layout-4 digi-card-new  ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ fontStyle: CardStylesofCard ? CardStylesofCard?.style : "Lato", fontFamily: CardStylesofCard ? CardStylesofCard?.font : "Lato", fontWeight: getFontWeight(CardStylesofCard?.style), fontSize: CardStylesofCard ? CardStylesofCard?.size : '', color: CardStylesofCard ? CardStylesofCard?.colorSecondary : '', backgroundColor: bgColor }}>
                <Box className="preview-card all-cards">
                    <div id='Card-firstPart-createNew'>
                        <Link to={`/card/${card}`}>
                            <div className={`preview-card-upper layout-4 full-bg-cover ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ backgroundImage: `url(${profilePicture})` }}>

                                <div className="favorite-icon icon flex-center" onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleFavoriteClick(card);
                                }}>
                                    {favoriteCards.includes(card) ?
                                        <FaStar color={"#FCB809"} /> : <FavIcon />
                                    }
                                </div>
                                <div className={`digi-card-label-container truncate ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ backgroundColor: layoutColor }}>
                                    <span className='digi-card-label' style={{ color: labelColor }}> {card}</span>
                                </div>
                                <div>
                                    <div>
                                        <CardWaveSmile bgColor={bgColor} strokeColor={layoutColor} />
                                    </div>
                                </div>
                                <div className='flex-center w-100pc'>
                                    <div className='layout-name-box layout2page' >
                                        <div className={`preview-card-names text-center previewcardNamePadding ${quantity === 1 ? "Smaller-screen" : ""}`}>
                                            <h3 className='truncate' style={{ color: colorPrimary ?? "black" }} title={userDetails.name}>{userDetails?.name}</h3>
                                            <h5 className='m-0 truncate' style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {(cardType === "Professional" || cardType === "Customize_Professional") ? (companyName + " - " + designation) : (title)}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>

                        {quantity !== 1 && (<>
                            {cardDetailsofCard?.summary?.length > 82 ? (
                                <div className='summary-container' style={{ marginTop: "50px" }}>
                                    {cardDetailsofCard?.summary?.slice(0, 82) + "..."}
                                </div>
                            ) : (
                                <div className='summary-container small-summary' style={{ marginTop: "50px" }}>
                                    {cardDetailsofCard?.summary}
                                </div>
                            )}
                        </>)
                        }
                    </div>
                    {/* <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} />
                    
                    */}
                    {cardDetailsofCard?.is_experience_current === true && (CardStylesofCard?.CardType === 'Professional' || CardStylesofCard?.CardType === "Customize_Professional") ? <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} /> : ""}

                    {(CardStylesofCard?.CardType === "Student" || CardStylesofCard?.CardType === "Customize_Student" || CardStylesofCard?.CardType === "Personal" || CardStylesofCard?.CardType === "Customize_Personal") && <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} />}
                    {/* <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} /> */}

                    {cardDetailsofCard?.is_experience_current === true && (CardStylesofCard?.CardType === 'Professional' || CardStylesofCard?.CardType === "Customize_Professional") ? <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} /> : ""}

                    {(CardStylesofCard?.CardType === "Student" || CardStylesofCard?.CardType === "Customize_Student" || CardStylesofCard?.CardType === "Personal" || CardStylesofCard?.CardType === "Customize_Personal") && <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} />}
                    {quantity !== 1 && (
                        <div className="mt-2 line-card place-at-bottom">
                            <div className="line-blue" style={{ backgroundColor: CardStylesofCard?.colorLayout }}></div>
                            <div className="icons_share_qr icon-alignment-card d-flex align-items-center justify-content-center">
                                <div className='icon-border me-3 flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    <ImQrcode className='icon-color' onClick={() => handleOpenDialog(card)} />
                                </div>
                                <div className='icon-border icon-verify-symbol me-3 flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    {/* {isVerified === true ? <VerifiedTickN /> : <NonVerifiedTickNew />} */}
                                    {isVerified === true || is_student_verified === true ?
                                        <VerifiedTickN title="Verified" /> :
                                        <NonVerifiedTickNew title="Not Verified" />
                                    }
                                </div>
                                <div className='icon-border flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    <IoMdShare className='icon-color' onClick={() => handleShareClick(card)} />
                                </div>
                            </div>
                        </div>
                    )}


                    {quantity !== 1 && (
                        contactDetails !== undefined ? (<>
                            <div className='quick-link-containerNew'>
                                {contactDetails?.call_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <MdOutlinePhoneIphone className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>Call</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.sms_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <SmsIcon className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>SMS</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.email_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <EmailIcon className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>E-mail</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.whatsapp_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <WhatsAppFilled className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>WhatsApp</div>
                                        </a>
                                    </div>
                                )}
                            </div></>) : (<>
                                <div className='quick-link-containerNew'>
                                    {ContactStylesofCard?.callNo?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <MdOutlinePhoneIphone className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>Call</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.textNo?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <SmsIcon className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>SMS</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.emailId?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <EmailIcon className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>E-mail</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.whatsapp?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <WhatsAppFilled className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>WhatsApp</div>
                                            </a>
                                        </div>
                                    )}
                                </div></>)

                    )}
                </Box >
            </div >
        </>
    )
}

const Layout6 = ({ layoutProps, favoriteCards, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, firstName, lastName, suffix,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, handleOpenDialog, handleShareClick, isVerified, is_student_verified,

        quantity, CardStylesofCard, sharePops, cardDetailsofCard, handleFavoriteClick,
        ContactStylesofCard, userDetails, dialogs, handleCloseDialog, handleShareClose, getFontWeight, contactDetails } = layoutProps;

    return (
        <>
            <div className={`item-card-display layout-4 digi-card-new  ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ fontStyle: CardStylesofCard ? CardStylesofCard?.style : "Lato", fontFamily: CardStylesofCard ? CardStylesofCard?.font : "Lato", fontWeight: getFontWeight(CardStylesofCard?.style), fontSize: CardStylesofCard ? CardStylesofCard.size : '', color: CardStylesofCard ? CardStylesofCard.colorSecondary : '', backgroundColor: bgColor }}>
                <Box className="preview-card all-cards">
                    <div id='Card-firstPart-createNew'>
                        <Link to={`/card/${card}`}>
                            <div className={`preview-card-upper layout-6 ${quantity === 1 ? "Smaller-screen" : ""}`}>
                                <div className="favorite-icon icon flex-center" onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleFavoriteClick(card);
                                }}>
                                    {favoriteCards.includes(card) ?
                                        <FaStar color={"#FCB809"} /> : <FavIcon />
                                    }
                                </div>
                                <div className={`digi-card-label-container truncate ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ backgroundColor: layoutColor }}>
                                    <span className='digi-card-label' style={{ color: labelColor }}> {card}</span>
                                </div>

                                <div className='layout-6-img-container'>
                                    <div className='layout-images-wrapper align-items-center'>
                                        <div className={`layoutout6-changesNew ${quantity === 1 ? "Smaller-screen" : ""}`}>
                                            <img className='layout-profile-picturelayout6 d-flex' src={profilePicture} alt="Profile" />
                                        </div>
                                        <div className={`layout-6-decor-line ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ backgroundColor: layoutColor }} />
                                    </div>
                                </div>

                            </div>
                            <div className={`preview-card-names text-center previewcardNamePadding mb-0 ${quantity === 1 ? "Smaller-screen" : ""}`}>
                                <h3 className='mb-0 truncate' style={{ color: colorPrimary ?? "black" }} title={userDetails.name}>{userDetails?.name}</h3>
                                <h5 className='mb-0 truncate' style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {(cardType === "Professional" || cardType === "Customize_Professional") ? (companyName + " - " + designation) : (title)}</h5>
                            </div>
                        </Link>

                        {quantity !== 1 && (<>
                            {cardDetailsofCard?.summary?.length > 82 ? (
                                <div className='summary-container' style={{ marginTop: "px" }}>
                                    {cardDetailsofCard?.summary?.slice(0, 82) + "..."}
                                </div>
                            ) : (
                                <div className='summary-container small-summary' style={{ marginTop: "10px" }}>
                                    {cardDetailsofCard?.summary}
                                </div>
                            )}
                        </>)
                        }
                    </div>

                    {quantity !== 1 && (
                        <div className="mt-2 line-card place-at-bottom">
                            <div className="line-blue" style={{ backgroundColor: CardStylesofCard?.colorLayout }}></div>
                            <div className="icons_share_qr icon-alignment-card d-flex align-items-center justify-content-center">
                                <div className='icon-border me-3 flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    <ImQrcode className='icon-color' onClick={() => handleOpenDialog(card)} />
                                </div>
                                <div className='icon-border icon-verify-symbol me-3 flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    {/* {isVerified === true ? <VerifiedTickN /> : <NonVerifiedTickNew />} */}
                                    {isVerified === true || is_student_verified === true ?
                                        <VerifiedTickN title="Verified" /> :
                                        <NonVerifiedTickNew title="Not Verified" />
                                    }
                                </div>
                                <div className='icon-border flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    <IoMdShare className='icon-color' onClick={() => handleShareClick(card)} />
                                </div>
                            </div>
                        </div>
                    )}
                    {/* <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} />
                     */}
                    {cardDetailsofCard?.is_experience_current === true && (CardStylesofCard?.CardType === 'Professional' || CardStylesofCard?.CardType === "Customize_Professional") ? <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} /> : ""}

                    {(CardStylesofCard?.CardType === "Student" || CardStylesofCard?.CardType === "Customize_Student" || CardStylesofCard?.CardType === "Personal" || CardStylesofCard?.CardType === "Customize_Personal") && <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} />}
                    {/* <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} /> */}

                    {cardDetailsofCard?.is_experience_current === true && (CardStylesofCard?.CardType === 'Professional' || CardStylesofCard?.CardType === "Customize_Professional") ? <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} /> : ""}

                    {(CardStylesofCard?.CardType === "Student" || CardStylesofCard?.CardType === "Customize_Student" || CardStylesofCard?.CardType === "Personal" || CardStylesofCard?.CardType === "Customize_Personal") && <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} />}



                    {quantity !== 1 && (
                        contactDetails !== undefined ? (<>
                            <div className='quick-link-containerNew'>
                                {contactDetails?.call_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <MdOutlinePhoneIphone className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>Call</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.sms_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <SmsIcon className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>SMS</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.email_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <EmailIcon className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>E-mail</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.whatsapp_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <WhatsAppFilled className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>WhatsApp</div>
                                        </a>
                                    </div>
                                )}
                            </div></>) : (<>
                                <div className='quick-link-containerNew'>
                                    {ContactStylesofCard?.callNo?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <MdOutlinePhoneIphone className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>Call</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.textNo?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <SmsIcon className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>SMS</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.emailId?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <EmailIcon className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>E-mail</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.whatsapp?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <WhatsAppFilled className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>WhatsApp</div>
                                            </a>
                                        </div>
                                    )}
                                </div></>)

                    )}
                </Box >
            </div >
        </>
    )
}

const Layout8 = ({ layoutProps, favoriteCards, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, firstName, lastName, suffix,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, handleOpenDialog, handleShareClick, isVerified, is_student_verified,

        quantity, CardStylesofCard, sharePops, cardDetailsofCard, handleFavoriteClick,
        ContactStylesofCard, userDetails, dialogs, handleCloseDialog, handleShareClose, getFontWeight, contactDetails } = layoutProps;

    return (
        <>
            <div className={`item-card-display layout-4 digi-card-new  ${quantity === 1 ? "Smaller-screen" : ""}`} style={{
                fontStyle: CardStylesofCard ? CardStylesofCard?.style : "Lato",
                fontFamily: CardStylesofCard ? CardStylesofCard?.font : "Lato", fontWeight: getFontWeight(CardStylesofCard?.style), fontSize: CardStylesofCard ? CardStylesofCard.size : '', color: CardStylesofCard ? CardStylesofCard.colorSecondary : '', backgroundColor: bgColor
            }}>
                <Box className="preview-card all-cards">
                    <div id='Card-firstPart-createNew'>
                        <Link to={`/card/${card}`}>
                            <div className={`preview-card-upper layout-8 ${quantity === 1 ? "Smaller-screen" : ""}`}>
                                <div className="favorite-icon icon flex-center" onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleFavoriteClick(card);
                                }}>
                                    {favoriteCards.includes(card) ?
                                        <FaStar color={"#FCB809"} /> : <FavIcon />
                                    }
                                </div>
                                <div className={`digi-card-label-container truncate ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ backgroundColor: layoutColor }}>
                                    <span className='digi-card-label' style={{ color: labelColor }}> {card}</span>
                                </div>

                                <div className='layout-8-img-container'>
                                    <div className='layout-images-wrapper flex-column align-items-center' style={{ marginTop: "18px" }}>
                                        <img className={`layout-profile-pictureNew ${quantity === 1 ? "Smaller-screen" : ""}`} src={profilePicture} alt="Profile" />
                                        <div className='layout-name-box' style={{ minHeight: "unset", width: "90%" }}>
                                            <div className='preview-card-names text-center'>
                                                <h3 className='truncate' style={{ color: colorPrimary ?? "black" }} title={userDetails.name}>{userDetails.name}</h3>
                                                <h5 className='truncate' style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {(cardType === "Professional" || cardType === "Customize_Professional") ? (companyName + " - " + designation) : (title)}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                        {quantity !== 1 && (<>
                            {cardDetailsofCard?.summary?.length > 82 ? (
                                <div className='summary-container' style={{ marginTop: "35px" }}>
                                    {cardDetailsofCard?.summary?.slice(0, 82) + "..."}
                                </div>
                            ) : (
                                <div className='summary-container small-summary' style={{ marginTop: "30px" }}>
                                    {cardDetailsofCard?.summary}
                                </div>
                            )}
                        </>)
                        }
                    </div>

                    {quantity !== 1 && (
                        <div className="mt-2 line-card place-at-bottom">
                            <div className="line-blue" style={{ backgroundColor: CardStylesofCard?.colorLayout }}></div>
                            <div className="icons_share_qr icon-alignment-card d-flex align-items-center justify-content-center">
                                <div className='icon-border me-3 flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    <ImQrcode className='icon-color' onClick={() => handleOpenDialog('Personal')} />
                                </div>
                                <div className='icon-border icon-verify-symbol me-3 flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    {/* {isVerified === true ? <VerifiedTickN /> : <NonVerifiedTickNew />} */}
                                    {isVerified === true || is_student_verified === true ?
                                        <VerifiedTickN title="Verified" /> :
                                        <NonVerifiedTickNew title="Not Verified" />
                                    }
                                </div>
                                <div className='icon-border flex-center' style={{ borderColor: CardStylesofCard?.colorLayout }}>
                                    <IoMdShare className='icon-color' onClick={() => handleShareClick(card)} />
                                </div>
                            </div>
                        </div>
                    )}
                    {/* <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} /> */}

                    {cardDetailsofCard?.is_experience_current === true && (CardStylesofCard?.CardType === 'Professional' || CardStylesofCard?.CardType === "Customize_Professional") ? <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} /> : ""}

                    {(CardStylesofCard?.CardType === "Student" || CardStylesofCard?.CardType === "Customize_Student" || CardStylesofCard?.CardType === "Personal" || CardStylesofCard?.CardType === "Customize_Personal") && <QrCodeDialog cardType={card} dialogOpen={dialogs[card]} handleCloseDialog={handleCloseDialog} />}
                    {/* <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} /> */}

                    {cardDetailsofCard?.is_experience_current === true && (CardStylesofCard?.CardType === 'Professional' || CardStylesofCard?.CardType === "Customize_Professional") ? <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} /> : ""}

                    {(CardStylesofCard?.CardType === "Student" || CardStylesofCard?.CardType === "Customize_Student" || CardStylesofCard?.CardType === "Personal" || CardStylesofCard?.CardType === "Customize_Personal") && <ShareQR cardType={card} sharePopover={sharePops[card]} onClose={handleShareClose} />}

                    {/* {quantity !== 1 && (
                        <>
                            <div className='quick-link-containerNew'>
                                {ContactStylesofCard?.callNo?.visible && (
                                    <div className='flex-center flex-column quick-link-icon'> */}
                    {/* {console.log("ContactStyles.callNo.input : ", ContactStylesofCard.callNo.input)} */}
                    {/* <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}><MdOutlinePhoneIphone className='icon-color3' /></div>
                                            <div className='contact-label'>Call</div>
                                        </a>
                                    </div>)}
                                {ContactStylesofCard?.textNo?.visible && (
                                    <div className='flex-center flex-column quick-link-icon'> */}
                    {/* <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'> */}
                    {/* <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}><SmsIcon className='icon-color3' /></div>
                                        <div className='contact-label'>SMS</div> */}
                    {/* </a> */}
                    {/* </div>)}
                                {ContactStylesofCard?.emailId?.visible && (
                                    <div className='flex-center flex-column quick-link-icon'> */}
                    {/* <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'> */}
                    {/* <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}><EmailIcon className='icon-color3' /></div>
                                        <div className='contact-label'>E-mail</div> */}
                    {/* </a> */}
                    {/* </div>)}
                                {ContactStylesofCard?.whatsapp?.visible && (
                                    <div className='flex-center flex-column quick-link-icon'> */}
                    {/* <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'> */}
                    {/* <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}><WhatsAppFilled className='icon-color3' /></div>
                                        <div className='contact-label'>WhatsApp</div> */}
                    {/* </a> */}
                    {/* </div>)}
                            </div>
                        </>
                    )} */}
                    {quantity !== 1 && (
                        contactDetails !== undefined ? (<>
                            <div className='quick-link-containerNew'>
                                {contactDetails?.call_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <MdOutlinePhoneIphone className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>Call</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.sms_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <SmsIcon className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>SMS</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.email_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <EmailIcon className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>E-mail</div>
                                        </a>
                                    </div>
                                )}
                                {contactDetails?.whatsapp_visible && (
                                    <div className='flex-center flex-column quick-link-icon'>
                                        <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'>
                                            <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                <WhatsAppFilled className='icon-color3' />
                                            </div>
                                            <div className='contact-label'>WhatsApp</div>
                                        </a>
                                    </div>
                                )}
                            </div></>) : (<>
                                <div className='quick-link-containerNew'>
                                    {ContactStylesofCard?.callNo?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`tel:${ContactStylesofCard.callNo.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <MdOutlinePhoneIphone className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>Call</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.textNo?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`sms:${ContactStylesofCard.textNo.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <SmsIcon className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>SMS</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.emailId?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`mailto:${ContactStylesofCard.emailId.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <EmailIcon className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>E-mail</div>
                                            </a>
                                        </div>
                                    )}
                                    {ContactStylesofCard?.whatsapp?.visible && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`https://wa.me/${ContactStylesofCard.whatsapp.input}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0 flex-center' style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                                    <WhatsAppFilled className='icon-color3' />
                                                </div>
                                                <div className='contact-label'>WhatsApp</div>
                                            </a>
                                        </div>
                                    )}
                                </div></>)

                    )}
                </Box>
            </div>

        </>
    )
}

const LayoutCa1 = ({ layoutProps, card }) => {
    const { prefix, firstName, lastName, suffix,
        companyName, designation, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, website, address, emailId, userDetails, contactDetails } = layoutProps;

    return (
        <><Link to={`/card/${card}`}>
            <div className="layout-prof ca-layout-1" style={{ backgroundColor: "white", height: "100%", fontSize: "12px" }}>
                <div className="ca-layout-upper py-2 px-2">
                    <div className='flex-center ps-1'>
                        <CAIndialogo />
                    </div>
                    <div className='preview-card-names' >
                        <h3 style={{ color: colorPrimary ?? "black" }}>{userDetails.name}</h3>
                        <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {companyName + " - " + designation}</h5>
                    </div>
                </div>
                <div className="ca-layout-body px-2">
                    <div className="d-flex justify-content-between">
                        <div className="flex-center ca-layout-left">
                            <div>
                                <QrCodeCard CARDNAME_id={card} size={100} />
                            </div>
                        </div>
                        <div className='ca-layout-right'>
                            <div className="d-flex flex-column justify-content-end py-3 pe-2">
                                <div className="d-flex justify-content-end align-items-center mb-2 gap-2">
                                    <div>{phoneNo}</div>
                                    <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <PhoneIphoneRoundedIcon className='ca-contact-svg' /> </div>
                                </div>
                                <div className="d-flex justify-content-end align-items-center mb-2 gap-2">
                                    <div>{emailId}</div>
                                    <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <EmailRounded className='ca-contact-svg' /> </div>
                                </div>
                                {(website && website?.is_visible) ?
                                    <a href={website?.info_value} target='_blank' rel='noreferrer'
                                        className="d-flex justify-content-end align-items-center mb-2 gap-2">
                                        <div>My Website</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <PublicIcon className='ca-contact-svg' /></div>
                                    </a> : <> </>}
                                {address && address?.length > 0 ?
                                    <div className="d-flex justify-content-end align-items-center gap-2">
                                        <div>{address?.join(", ")}</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <LocationOnRoundedIcon className='ca-contact-svg' /></div>
                                    </div> : <> </>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ca-layout-footer">
                    <div className='footer-shape' style={{ backgroundColor: layoutColor }}>{companyName}</div>
                </div>
            </div>
        </Link>
        </>
    )
}

const LayoutCa2 = ({ layoutProps, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website, address, userDetails, contactDetails } = layoutProps;

    return (
        <>
            <Link to={`/card/${card}`}>
                <div className="layout-prof ca-layout-2" style={{ backgroundColor: "white", height: "100%", fontSize: "12px" }}>
                    <div className="ca-layout-upper flex-row-reverse py-2 px-2">
                        <div className='flex-center ps-1'>
                            <CAIndialogo />
                        </div>
                        <div className='preview-card-names'>
                            <h3 style={{ color: colorPrimary ?? "black" }}>{userDetails.name}</h3>
                            <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {companyName + " - " + designation}</h5>
                        </div>
                    </div>
                    <div className="ca-layout-body px-2">
                        <div className="d-flex flex-row-reverse justify-content-between">
                            <div className="flex-center">
                                <div>
                                    <QrCodeCard CARDNAME_id={cardType} size={100} />
                                </div>
                            </div>
                            <div>
                                <div className="d-flex flex-column justify-content-end py-3 ps-2">
                                    <div className="d-flex flex-row-reverse justify-content-end align-items-center mb-2 gap-2">
                                        <div>{phoneNo}</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <PhoneIphoneRoundedIcon className='ca-contact-svg' /> </div>
                                    </div>
                                    <div className="d-flex flex-row-reverse justify-content-end align-items-center mb-2 gap-2">
                                        <div>{emailId}</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <EmailRounded className='ca-contact-svg' /> </div>
                                    </div>
                                    {(website && website?.is_visible) ?
                                        <a href={website?.info_value} target='_blank' rel='noreferrer'
                                            className="d-flex flex-row-reverse justify-content-end align-items-center mb-2 gap-2">
                                            <div>My Website</div>
                                            <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <PublicIcon className='ca-contact-svg' /></div>
                                        </a> : <> </>}
                                    {address && address?.length > 0 ?
                                        <div className="d-flex flex-row-reverse justify-content-end align-items-center gap-2">
                                            <div>{address?.join(", ")}</div>
                                            <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <LocationOnRoundedIcon className='ca-contact-svg' /></div>
                                        </div> : <> </>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ca-layout-footer">
                        <div className='footer-shape' style={{ backgroundColor: layoutColor }}>{companyName}</div>
                    </div>
                </div>
            </Link>
        </>
    )
}

const LayoutHr1 = ({ layoutProps, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, colorTitle, bgColor, layoutColor, labelColor, phoneNo, emailId, address, userDetails } = layoutProps;

    return (<>
        <Link to={`/card/${card}`}>
            <div className="layout-prof hr-layout-1" style={{ height: "100%" }}>
                <div className="row gx-0">
                    <div className="col-6 col-xl-5" style={{ backgroundColor: "#3C4048" }}>
                        <div className="flex-center h-100pc">
                            <div className="hr-image-container" style={{ borderColor: layoutColor }}>
                                <div className='hr-image-div' >
                                    <img src={profilePicture} alt='profile' />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-xl-7" style={{ backgroundColor: "#F4F4F4" }}>
                        <div className="hr-layout-right word-break py-2">
                            <div className='preview-card-names px-3' >
                                <h3 style={{ color: colorPrimary ?? "black" }}>{userDetails?.name}</h3>
                                <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {companyName + " - " + designation}</h5>
                            </div>
                            <div className="hr-info-box">
                                <div className="hr-info-wrapper">
                                    <div className="hr-info-property" style={{ color: colorTitle ?? "black" }}>Contact</div>
                                    <div className="hr-info-value">{phoneNo}</div>
                                </div>
                                <div className="hr-info-wrapper">
                                    <div className="hr-info-property" style={{ color: colorTitle ?? "black" }}>E-mail</div>
                                    <div className="hr-info-value">{emailId}</div>
                                </div>
                                {address?.length > 0 ?
                                    <div className="hr-info-wrapper">
                                        <div className="hr-info-property" style={{ color: colorTitle ?? "black" }}>Address</div>
                                        <div className="hr-info-value">{address?.join(", ")}</div>
                                    </div> : <> </>}
                                <div className="hr-info-icons-bar py-3 px-2" style={{ backgroundColor: layoutColor }}>
                                    <div className="hr-info-icon" style={{ backgroundColor: bgColor }}><CallRoundedIcon className='hr-info-svg' style={{ color: layoutColor }} /></div>
                                    <div className="hr-info-icon" style={{ backgroundColor: bgColor }}><EmailRounded className='hr-info-svg' style={{ color: layoutColor }} /></div>
                                    <div className="hr-info-icon" style={{ backgroundColor: bgColor }}><LocationOnRoundedIcon className='hr-info-svg' style={{ color: layoutColor }} /></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    </>
    )

}

const LayoutHr2 = ({ layoutProps, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, colorTitle, bgColor, layoutColor, labelColor, phoneNo, emailId, address, userDetails } = layoutProps;

    return (<>
        <Link to={`/card/${card}`}>
            <div className="layout-prof hr-layout-2" style={{ backgroundColor: "white", height: "100%" }}>
                <div className="row gx-0 h-100pc" >
                    <div className="col-5 py-3" style={{ backgroundColor: "#24252f" }}>
                        <div className="flex-center flex-column">
                            <div className='preview-card-names text-center'>
                                <h3 style={{ color: colorPrimary ?? "black" }}>{userDetails.name}</h3>
                                <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {designation} </h5>
                                <div className='hr-decor-line' style={{ backgroundColor: layoutColor }} />
                            </div>
                            <div className="hr-image-container text-center">
                                <div className='hr-image-div'>
                                    <img src={companyLogo} alt='profile' />
                                </div>
                                <h5 className='my-1' style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)", fontSize: "14px" }}>{companyName}</h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-7 p-3 d-flex align-items-center">
                        <div className="hr-info-box ps-2">
                            <div className="hr-info-wrapper" style={{ borderBottom: `1px solid ${layoutColor}` }}>
                                <div className="hr-info-value">{phoneNo}</div>
                            </div>
                            <div className="hr-info-wrapper" style={{ borderBottom: `1px solid ${layoutColor}` }}>
                                <div className="hr-info-value">{emailId}</div>
                            </div>
                            {(address?.length > 0) ?
                                <div className="hr-info-wrapper">
                                    <div className="hr-info-value">{address?.join(", ")}</div>
                                </div> : <> </>}
                            <div className='shape-outer-1' /*style={{backgroundColor: bgColor, backgroundImage: `url(${HrOuterShape1})`}}*/> <HrOuterShape1 color={layoutColor} /> </div>
                            <div className='shape-outer-2' /*style={{backgroundColor: bgColor, backgroundImage: `url(${HrOuterShape2})`}}*/> <HrOuterShape1 color={layoutColor} /> </div>
                            <div className='shape-inner hr-info-icons-bar' style={{ backgroundImage: `url(${HrInnerShape})` }}>
                                <div className="hr-info-icon"><CallRoundedIcon className='hr-info-svg' style={{ color: layoutColor }} /></div>
                                <div className="hr-info-icon"><EmailRounded className='hr-info-svg' style={{ color: layoutColor }} /></div>
                                <div className="hr-info-icon"><LocationOnRoundedIcon className='hr-info-svg' style={{ color: layoutColor }} /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    </>
    )
}

const LayoutBank1 = ({ layoutProps, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website, address, userDetails } = layoutProps;

    return (
        <>
            <Link to={`/card/${card}`}>
                <div className="layout-prof bank-layout-1" style={{ backgroundColor: "white", height: "100%" }}>
                    <div className="bank-layout-upper d-flex justify-content-between py-2">
                        <div className='upper-left flex-center ms-1' >
                            <img src={companyLogo} alt='Company Logo' />
                        </div>
                        <div className='preview-card-names px-3' style={{ textAlign: "right" }}>
                            <h3 style={{ color: colorPrimary ?? "black" }}>{userDetails.name}</h3>
                            <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {designation}</h5>
                        </div>
                    </div>
                    <div className="ca-layout-body">
                        <div className="d-flex flex-row-reverse justify-content-between py-1">
                            <div className="flex-center ca-layout-left">
                                <div>
                                    <QrCodeCard CARDNAME_id={cardType} size={100} />
                                </div>
                            </div>
                            <div className='ca-layout-right'>
                                <div className="d-flex flex-column justify-content-end py-3 ps-2">
                                    <div className="d-flex flex-row-reverse justify-content-end align-items-center mb-2 gap-2">
                                        <div>{phoneNo}</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <PhoneIphoneRoundedIcon className='ca-contact-svg' /> </div>
                                    </div>
                                    <div className="d-flex flex-row-reverse justify-content-end align-items-center mb-2 gap-2">
                                        <div>{emailId}</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <EmailRounded className='ca-contact-svg' /> </div>
                                    </div>
                                    {(website && website?.is_visible) ?
                                        <a href={website?.info_value} target='_blank' rel='noreferrer'
                                            className="d-flex flex-row-reverse justify-content-end align-items-center mb-2 gap-2">
                                            <div>My Website</div>
                                            <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <PublicIcon className='ca-contact-svg' /></div>
                                        </a> : <> </>}
                                    {(address?.length > 0) ?
                                        <div className="d-flex flex-row-reverse justify-content-end align-items-center gap-2">
                                            <div>{address?.join(", ")}</div>
                                            <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <LocationOnRoundedIcon className='ca-contact-svg' /></div>
                                        </div> : <> </>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Link>
        </>
    )
}

const LayoutBank2 = ({ layoutProps, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website, address, userDetails } = layoutProps;

    return (
        <>
            <Link to={`/card/${card}`}>
                <div className="layout-prof bank-layout-2" style={{ backgroundColor: "white", height: "100%", fontSize: "14px" }}>
                    <div className="bank-layout-upper d-flex justify-content-between py-2">
                        <div className='flex-center ms-1 upper-left'>
                            <img src={companyLogo} alt='Company Logo' />
                        </div>
                        <div className="d-flex flex-column align-items-end justify-content-end">
                            {
                                [0, 1, 2, 3, 4].map(index => (
                                    <div key={index} style={{ width: `${90 + index * 6}px`, height: "1px", backgroundColor: "black", marginBottom: "4px" }}></div>
                                ))
                            }
                        </div>
                    </div>
                    <div className="ca-layout-body">
                        <div className="d-flex flex-row-reverse justify-content-between py-1">
                            <div className="flex-center ca-layout-left">
                                <div>
                                    <QrCodeCard CARDNAME_id={cardType} size={100} />
                                </div>
                            </div>
                            <div className='ca-layout-right'>
                                <div className='preview-card-names ps-2'>
                                    <h3 style={{ color: colorPrimary ?? "black" }}>{userDetails.name}</h3>
                                    <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {designation}</h5>
                                </div>
                                <div className="d-flex flex-column justify-content-end p-2">
                                    <div className="d-flex flex-row-reverse justify-content-end align-items-center mb-2 gap-2">
                                        <div>{phoneNo}</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <PhoneIphoneRoundedIcon className='ca-contact-svg' /> </div>
                                    </div>
                                    <div className="d-flex flex-row-reverse justify-content-end align-items-center mb-2 gap-2">
                                        <div>{emailId}</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <EmailRounded className='ca-contact-svg' /> </div>
                                    </div>
                                    {(website && website?.is_visible) ?
                                        <a href={website?.info_value} target='_blank' rel='noreferrer'
                                            className="d-flex flex-row-reverse justify-content-end align-items-center mb-2 gap-2">
                                            <div>My Website</div>
                                            <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <PublicIcon className='ca-contact-svg' /></div>
                                        </a> : <> </>}
                                    {(address?.length > 0) ? <div className="d-flex flex-row-reverse justify-content-end align-items-center gap-2">
                                        <div>{address?.join(", ")}</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <LocationOnRoundedIcon className='ca-contact-svg' /></div>
                                    </div> : <> </>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Link>
        </>
    )
}

const LayoutFl1 = ({ layoutProps, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website, address, userDetails } = layoutProps;

    return (
        <>
            <Link to={`/card/${card}`}>
                <div className="layout-prof freelancer-layout-1" style={{ background: `linear-gradient(0deg, ${bgColor}, ${layoutColor})`, height: "100%" }}>
                    <div className='freelancer-polygon left-shape' />
                    <div className='freelancer-polygon right-shape' />
                    <div className="row gx-0" >
                        <div className="col-5 flex-center">
                            <div className='flex-center fl-layout-logo-container' style={{ borderColor: colorSecondary }}>
                                <div className='flex-center fl-logo-div'>
                                    <img src={companyLogo} />
                                </div>
                            </div>
                        </div>
                        <div className="col-7">
                            <div className='fl-layout-right'>
                                <div className='preview-card-names'>
                                    <h3 style={{ color: colorPrimary ?? "black" }}>{userDetails.name}</h3>
                                    <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {designation}</h5>
                                </div>
                                <div>
                                    <div className="d-flex flex-column py-3 pe-2" style={{ textAlign: "left" }}>
                                        <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                            <div>{phoneNo}</div>
                                            <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <CallRoundedIcon className='ca-contact-svg' /> </div>
                                        </div>
                                        <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                            <div>{emailId}</div>
                                            <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <EmailRounded className='ca-contact-svg' /> </div>
                                        </div>
                                        {(website && website?.is_visible) ?
                                            <a href={website?.info_value} target='_blank' rel='noreferrer'
                                                className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                                <div>My Website</div>
                                                <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <PublicIcon className='ca-contact-svg' /></div>
                                            </a> : <> </>}
                                        {(address?.length > 0) ?
                                            <div className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                                <div>{address?.join(", ")}</div>
                                                <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <LocationOnRoundedIcon className='ca-contact-svg' /></div>
                                            </div> : <> </>}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </Link>
        </>
    )
}

const LayoutFl2 = ({ layoutProps, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website, address, userDetails } = layoutProps;

    return (
        <>
            <Link to={`/card/${card}`}>
                <div className="layout-prof freelancer-layout-2" style={{ background: `linear-gradient(0deg, ${bgColor}, ${layoutColor})`, height: "100%" }}>
                    <div className='freelancer-polygon left-shape' />
                    <div className='freelancer-polygon right-shape flex-center'>
                        <div className='flex-center fl-layout-logo-container'>
                            <img src={companyLogo} />
                        </div>
                    </div>
                    <div className="row gx-0">
                        <div className="col-8">
                            <div className='word-break fl-layout-left'>
                                <div className='preview-card-names'>
                                    <h3 style={{ color: colorPrimary ?? "black", }}>{userDetails.name}</h3>
                                    <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {designation}</h5>
                                </div>
                                <div>
                                    <div className="d-flex flex-column py-3 pe-2" style={{ textAlign: "left" }}>
                                        <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                            <div>{phoneNo}</div>
                                            <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <CallRoundedIcon className='ca-contact-svg' /> </div>
                                        </div>
                                        <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                            <div>{emailId}</div>
                                            <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <EmailRounded className='ca-contact-svg' /> </div>
                                        </div>
                                        {(website && website?.is_visible) ?
                                            <a href={website?.info_value} target='_blank' rel='noreferrer'
                                                className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                                <div>My Website</div>
                                                <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <PublicIcon className='ca-contact-svg' /></div>
                                            </a> : <> </>}
                                        {(address?.length > 0) ?
                                            <div className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                                <div>{address?.join(", ")}</div>
                                                <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <LocationOnRoundedIcon className='ca-contact-svg' /></div>
                                            </div> : <> </>}
                                    </div>
                                </div>

                            </div>
                        </div>
                        {/* <div className="col-5 flex-center">
                        <div className='flex-center' style={{ width: "100%", height: "60%", borderRight: "1px solid white" }}>
                            <div className='flex-center' style={{ maxHeight: "60%", maxWidth: "60%" }}>
                                <img src={companyLogo} style={{ height: "100%", width: "100%", objectFit: "contain" }} />
                            </div>
                        </div>
                    </div> */}
                    </div>
                </div>
            </Link>
        </>
    )
}

const LayoutCs1 = ({ layoutProps, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, address, userDetails } = layoutProps;

    return (
        <>
            <Link to={`/card/${card}`}>
                <div className="layout-prof cs-layout-1 px-4" style={{ backgroundColor: bgColor, height: "100%" }}>
                    <div className="cs-layout-upper d-flex align-items-center pt-2">
                        <div className="cs-layout-logo-container pe-2">
                            <img src={companyLogo} alt="Company Logo" />
                        </div>
                        <span>{companyName}</span>
                    </div>
                    <div className="row gx-0">
                        <div className="col-8">
                            <div className='preview-card-names pt-3'>
                                <h3 className='mb-1' style={{ color: colorPrimary ?? "black" }}>{userDetails.name}</h3>
                            </div>
                            <div className="d-flex flex-column py-3" style={{ textAlign: "left" }}>
                                <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                    <div>{phoneNo}</div>
                                    <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <CallRoundedIcon className='ca-contact-svg' /> </div>
                                </div>
                                <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                    <div>{emailId}</div>
                                    <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <EmailRounded className='ca-contact-svg' /> </div>
                                </div>
                                {(address?.length > 0) ?
                                    <div className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                        <div>{address?.join(", ")}</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <LocationOnRoundedIcon className='ca-contact-svg' /></div>
                                    </div> : <> </>}
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="flex-center">
                                <div className="cs-image-container">
                                    <div className='cs-image-div'>
                                        <img src={profilePicture} alt='profile' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Link>
        </>
    )
}

const LayoutCs2 = ({ layoutProps, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website, address, userDetails } = layoutProps;

    return (
        <>
            <Link to={`/card/${card}`}>
                <div className="layout-prof cs-layout-2 px-3" style={{ backgroundColor: bgColor, height: "100%" }}>
                    <div className="row gx-0">
                        <div className="col-5">
                            <div className="cs-layout-left">
                                <div className="rhombus-clip hr-image-wrapper flex-center" style={{ backgroundColor: layoutColor }}>
                                    <div className='rhombus-clip cs-image-container'>
                                        <img src={profilePicture} alt='profile' />
                                    </div>
                                </div>
                            </div>
                            <div className='rhombus-clip cs-shape-full top' style={{ backgroundColor: layoutColor }} />
                            <div className='rhombus-clip cs-shape-full bottom' style={{ backgroundColor: layoutColor }} />
                            <div className='rhombus-clip cs-shape-full top-corner' style={{ backgroundColor: layoutColor }} />
                            <div className='rhombus-clip cs-shape-full bottom-corner' style={{ backgroundColor: layoutColor }} />
                            <div className='iso-triangle-clip cs-shape-partial top' style={{ backgroundColor: layoutColor }} />
                            <div className='iso-triangle-clip cs-shape-partial bottom' style={{ backgroundColor: layoutColor }} />
                            <div className='rhombus-clip cs-shape-small top' style={{ backgroundColor: layoutColor }} />
                            <div className='rhombus-clip cs-shape-small bottom' style={{ backgroundColor: layoutColor }} />
                        </div>
                        <div className="col-7">
                            <div className='cs-layout-right word-break'>
                                <div className='preview-card-names pt-3'>
                                    <h3 style={{ color: colorPrimary ?? "black" }}>{userDetails.name}</h3>
                                    <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {companyName + " - " + designation}</h5>
                                </div>
                                <div className="d-flex flex-column justify-content-end py-3 pe-2">
                                    <div className="d-flex justify-content-end align-items-top mb-2 gap-2">
                                        <div>{phoneNo}</div>
                                        <div className='ca-contact-icon' style={{ borderColor: layoutColor }}> <CallRoundedIcon className='ca-contact-svg' style={{ color: layoutColor }} /> </div>
                                    </div>
                                    <div className="d-flex justify-content-end align-items-top mb-2 gap-2">
                                        <div>{emailId}</div>
                                        <div className='ca-contact-icon' style={{ borderColor: layoutColor }}> <EmailRounded className='ca-contact-svg' style={{ color: layoutColor }} /> </div>
                                    </div>
                                    {(website && website?.is_visible) ?
                                        <a href={website?.info_value} target='_blank' rel='noreferrer'
                                            className="d-flex justify-content-end align-items-top mb-2 gap-2">
                                            <div>My Website</div>
                                            <div className='ca-contact-icon' style={{ borderColor: layoutColor }}> <PublicIcon className='ca-contact-svg' style={{ color: layoutColor }} /></div>
                                        </a> : <> </>}
                                    {(address?.length > 0) ?
                                        <div className="d-flex justify-content-end align-items-top gap-2">
                                            <div>{address?.join(", ")}</div>
                                            <div className='ca-contact-icon' style={{ borderColor: layoutColor }}> <LocationOnRoundedIcon className='ca-contact-svg' style={{ color: layoutColor }} /></div>
                                        </div> : <> </>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Link>
        </>
    )
}

const LayoutIt1 = ({ layoutProps, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website, userDetails } = layoutProps;

    return (
        <>
            <Link to={`/card/${card}`}>
                <div className="layout-prof it-layout-1 p-5" style={{ backgroundColor: bgColor, height: "100%" }}>
                    <ITGridShape1 className='it-layout-shape shape-1' />
                    <ITGridShape2 className='it-layout-shape shape-2' />
                    <ITGridShape3 className='it-layout-shape shape-3' />
                    <ITGridShape4 className='it-layout-shape shape-4' />
                    <ITGridShape5 className='it-layout-shape shape-5' />
                    <div>
                        <center className='word-break'>
                            <div className='preview-card-names text-center'>
                                <h3 style={{ color: colorPrimary ?? "black" }}>{userDetails.name}</h3>
                                <h5 className='mb-1' style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {designation}</h5>
                                <div className='it-names-underline' style={{ backgroundColor: layoutColor }} />
                            </div>

                            <div className="it-contacts-container d-flex flex-column py-3">
                                <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                    <div className='itech-contact-value'>{phoneNo}</div>
                                    <div className='itech-contact-icon'> <CallRoundedIcon className='itech-contact-svg' style={{ color: layoutColor }} /> </div>
                                </div>
                                <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                    <div className='itech-contact-value'>{emailId}</div>
                                    <div className='itech-contact-icon'> <EmailRounded className='itech-contact-svg' style={{ color: layoutColor }} /> </div>
                                </div>
                                {(website && website?.is_visible) ?
                                    <a href={website?.info_value} target='_blank' rel='noreferrer'
                                        className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                        <div className='itech-contact-value'>My Website</div>
                                        <div className='itech-contact-icon'> <PublicIcon className='itech-contact-svg' style={{ color: layoutColor }} /></div>
                                    </a> : <> </>}
                            </div>
                        </center>
                    </div>
                </div>
            </Link>
        </>
    )
}

const LayoutIt2 = ({ layoutProps, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website, address, userDetails } = layoutProps;

    const cardRef = useRef(null);
    const rightShapeRef = useRef(null);

    useEffect(() => {
        const adjustShapeHeight = () => {
            const cardHeight = cardRef.current.offsetHeight;
            const shapeHeight = cardHeight * 1.26; // Adjust this multiplier based on your design requirements
            rightShapeRef.current.style.height = `${shapeHeight}px`;
        };

        adjustShapeHeight();

        window.addEventListener('resize', adjustShapeHeight);
        return () => window.removeEventListener('resize', adjustShapeHeight);
    }, []);

    return (
        <>
            <Link to={`/card/${card}`}>
                <div className="layout-prof it-layout-2" ref={cardRef} style={{ backgroundColor: bgColor, height: "100%" }}>
                    <div className="row gx-0">
                        <div className="col-7 it-layout-left">
                            <div className='preview-card-names'>
                                <h3 style={{ color: colorPrimary ?? "black" }}>{userDetails.name}</h3>
                                <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {designation}</h5>
                            </div>
                            <div className="it-contacts-container d-flex flex-column py-3">
                                <div className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                    <div className='itech-contact-value'>{phoneNo}</div>
                                    <div className='itech-contact-icon'> <CallRoundedIcon className='itech-contact-svg' style={{ color: layoutColor }} /> </div>
                                </div>
                                <div className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                    <div className='itech-contact-value'>{emailId}</div>
                                    <div className='itech-contact-icon'> <EmailRounded className='itech-contact-svg' style={{ color: layoutColor }} /> </div>
                                </div>
                                {(website && website?.is_visible) ?
                                    <a href={website?.info_value} target='_blank' rel='noreferrer' className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                        <div className='itech-contact-value'>My Website</div>
                                        <div className='itech-contact-icon'> <PublicIcon className='itech-contact-svg' style={{ color: layoutColor }} /></div>
                                    </a> : <> </>}
                                {(address?.length > 0) ?
                                    <div className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                        <div className='itech-contact-value'>{address?.join(", ")}</div>
                                        <div className='itech-contact-icon'> <LocationOnRoundedIcon className='itech-contact-svg' style={{ color: layoutColor }} /></div>
                                    </div> : <> </>}
                            </div>

                        </div>
                        <div className="col-5 it-layout-right flex-center">
                            <div className="it-point-left-shape" ref={rightShapeRef} style={{ background: `linear-gradient(135deg, ${layoutColor}, transparent)` }} >
                                <div className='inner-shape flex-center' style={{ backgroundColor: bgColor }} >
                                    <div className='it-company-info flex-center flex-column' >
                                        <div className='it-company-logo' style={{ maxHeight: "60px", maxWidth: "60px", overflow: "hidden" }}>
                                            <img src={companyLogo} alt='Company Logo' style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                                        </div>
                                        <span className='my-1' style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}>{companyName}</span>
                                    </div>
                                </div>
                            </div>
                            {/* <div className='flex-center flex-column' style={{position: "relative", left: "10px", top: "8px", zIndex: 5}}>
                                <div style={{maxHeight: "60px", maxWidth: "60px", overflow: "hidden"}}>
                                    <img src={companyLogo} alt='Company Logo' style={{width: "100%", height: "100%", objectFit: "contain"}} />
                                </div>
                                <h5 className='my-1' style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)", fontSize: "12px" }}>{companyName}</h5>
                            </div> */}
                        </div>
                        <div className="it-point-up-shape" style={{ background: `linear-gradient(135deg, ${layoutColor}, transparent)` }} >
                            <div className='inner-shape' style={{ backgroundColor: bgColor }} />
                        </div>
                    </div>
                </div>
            </Link>
        </>
    )
}

const LayoutAdv1 = ({ layoutProps, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website, userDetails } = layoutProps;

    return (
        <>
            <Link to={`/card/${card}`}>
                <div className="layout-prof adv-layout-1" style={{ backgroundColor: bgColor, height: "100%", fontSize: "12px" }}>
                    <div className='d-flex'>
                        <div className='adv-shapes-cluster'>
                            <div className="adv-layout-polygon flex-center" style={{ backgroundColor: layoutColor }}>
                                <div className="adv-layout-polygon-content">
                                    <div className='adv-layout-logo-container' >
                                        <img src={companyLogo} alt='Company Logo' />
                                    </div>
                                </div>
                            </div>
                            <BottomLight className='adv-bottom-light' />
                            <BottomBold className='adv-bottom-bold' />
                            <TopLight className='adv-top-light' />
                            <TopBold className='adv-top-bold' />
                        </div>
                        <div className='adv-layout-body py-5 px-3'>
                            <div className='preview-card-names' style={{ textAlign: "right" }}>
                                <h3 style={{ color: colorPrimary ?? "black" }}>{userDetails.name}</h3>
                                <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {companyName + " - " + designation}</h5>
                            </div>
                            <div className="adv-contact-container d-flex flex-column py-3">
                                <div className="d-flex justify-content-end align-items-top mb-2 gap-2">
                                    <div className='itech-contact-value'>{phoneNo}</div>
                                    <div className='adv-contact-icon' style={{ backgroundColor: layoutColor }}> <CallRoundedIcon className='adv-contact-svg' style={{ color: bgColor }} /> </div>
                                </div>
                                <div className="d-flex justify-content-end align-items-top mb-2 gap-2">
                                    <div className='itech-contact-value'>{emailId}</div>
                                    <div className='adv-contact-icon' style={{ backgroundColor: layoutColor }}> <EmailRounded className='adv-contact-svg' style={{ color: bgColor }} /> </div>
                                </div>
                                {(website && website?.is_visible) ?
                                    <a href={website?.info_value} target='_blank' rel='noreferrer'
                                        className="d-flex justify-content-end align-items-top gap-2">
                                        <div className='itech-contact-value'>My Website</div>
                                        <div className='adv-contact-icon' style={{ backgroundColor: layoutColor }}> <PublicIcon className='adv-contact-svg' style={{ color: bgColor }} /> </div>
                                    </a> : <> </>}
                            </div>
                        </div>
                    </div>
                </div>
            </Link>
        </>
    )
}

const LayoutAdv2 = ({ layoutProps, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website, userDetails } = layoutProps;


    const [firstName, lastName] = userDetails.name.split(' ');

    return (
        <>
            <Link to={`/card/${card}`}>
                <div className="layout-prof adv-layout-2" style={{ backgroundColor: bgColor, height: "100%", fontSize: "12px" }}>
                    <div className='d-flex' style={{ height: "100%" }}>
                        <div className='adv-layout-left'>
                            <div className='adv-img-container'>
                                <img src={profilePicture} alt='Profile' />
                            </div>
                        </div>
                        <div className='adv-layout-body word-break' style={{ width: "65%" }}>
                            <div className='border-with-text preview-card-names' style={{ borderColor: layoutColor }}>
                                <h3 style={{ color: colorPrimary ?? "black", fontSize: "16px", marginBottom: "4px", width: "fit-content", paddingLeft: "5px" }}>
                                    <div className='d-flex'>{firstName}</div>
                                    <div className='d-flex'>{lastName}</div>
                                </h3>
                                <h5 className='text-on-border' style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)", backgroundColor: bgColor }}> {designation}</h5>
                            </div>
                            <div className="adv-contact-container d-flex flex-column pt-3" style={{ fontSize: "12px" }}>
                                <div className='itech-contact-value mb-1'>Your Address</div>
                                <div className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                    <div className='itech-contact-value'>{phoneNo}</div>
                                    <div className='itech-contact-icon'> <CallRoundedIcon className='itech-contact-svg' style={{ color: layoutColor }} /> </div>
                                </div>
                                <div className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                    <div className='itech-contact-value'>{emailId}</div>
                                    <div className='itech-contact-icon'> <EmailRounded className='itech-contact-svg' style={{ color: layoutColor }} /> </div>
                                </div>
                                {(website && website?.is_visible) ?
                                    <a href={website?.info_value} target='_blank' rel='noreferrer'
                                        className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                        <div className='itech-contact-value'>My Website</div>
                                        <div className='itech-contact-icon'> <PublicIcon className='itech-contact-svg' style={{ color: layoutColor }} /></div>
                                    </a> : <> </>}
                            </div>
                        </div>
                    </div>
                </div>
            </Link>
        </>
    )
}

const LayoutDr1 = ({ layoutProps, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, address, userDetails } = layoutProps;

    return (
        <>
            <Link to={`/card/${cardType}`}>
                <div className="layout-prof dr-layout-1" style={{ backgroundColor: bgColor, height: "100%" }}>
                    <div className="row gx-0">

                        <div className="col-6 dr-layout-left word-break">
                            <div className='preview-card-names'>
                                <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{userDetails.name}</h3>
                                <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {designation}</h5>
                            </div>
                            <div className="dr-contact-container d-flex flex-column py-3">
                                <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                    <div className='dr-contact-value'>{phoneNo}</div>
                                    <div className='dr-contact-icon' style={{ backgroundColor: layoutColor }}> <CallRoundedIcon className='dr-contact-svg' style={{ color: bgColor }} /> </div>
                                </div>
                                <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                    <div className='dr-contact-value'>{emailId}</div>
                                    <div className='dr-contact-icon' style={{ backgroundColor: layoutColor }}> <EmailRounded className='dr-contact-svg' style={{ color: bgColor }} /> </div>
                                </div>
                                {(address?.length > 0) ?
                                    <div className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                        <div className='dr-contact-value'>{address?.join(", ")}</div>
                                        <div className='dr-contact-icon' style={{ backgroundColor: layoutColor }}> <LocationOnRoundedIcon className='dr-contact-svg' style={{ color: bgColor }} /></div>
                                    </div> : <> </>}
                            </div>
                        </div>
                        <div className="col-6 dr-layout-right">
                            <div className='dr-profile-shapes-wrapper'>
                                <div className='parallelogram-clip dr-profile-container' >
                                    <img className='dr-profile-pic' src={profilePicture} alt='profile' />
                                </div>
                                <div className="dr-shape-top-left" style={{ backgroundColor: layoutColor }} />
                                <div className="parallelogram-clip dr-shape-bottom-right" style={{ backgroundColor: colorPrimary }} />
                            </div>
                        </div>

                    </div>
                </div>
            </Link>
        </>
    )
}

const LayoutDr2 = ({ layoutProps, card }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, address, userDetails } = layoutProps;

    return (
        <>
            <Link to={`/card/${card}`}>
                <div className="layout-prof dr-layout-2" style={{ backgroundColor: bgColor, height: "100%" }}>
                    <div className="row gx-0">
                        <div className="col-6 dr-layout-left-up word-break">
                            <div className='preview-card-names' >
                                <h3 style={{ color: colorPrimary ?? "black" }}>{userDetails.name}</h3>
                                <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {designation}</h5>
                            </div>
                        </div>
                        <div className="row gx-0">
                            <div className="col-7 dr-layout-left-down word-break">
                                <div className="d-flex flex-column py-3 dr-contact-container" >
                                    <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                        <div className='dr-contact-value'>{phoneNo}</div>
                                        <div className='dr-contact-icon' style={{ backgroundColor: layoutColor }}> <CallRoundedIcon className='dr-contact-svg' style={{ color: bgColor }} /> </div>
                                    </div>
                                    <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                        <div className='dr-contact-value'>{emailId}</div>
                                        <div className='dr-contact-icon' style={{ backgroundColor: layoutColor }}> <EmailRounded className='dr-contact-svg' style={{ color: bgColor }} /> </div>
                                    </div>
                                    {(address?.length > 0) ?
                                        <div className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                            <div className='dr-contact-value'>{address?.join(", ")}</div>
                                            <div className='dr-contact-icon' style={{ backgroundColor: layoutColor }}> <LocationOnRoundedIcon className='dr-contact-svg' style={{ color: bgColor }} /></div>
                                        </div> : <> </>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='dr-profile-shapes-wrapper'>
                        <div className='custom-polygon dr-profile-container' >
                            <img src={profilePicture} alt='profile' style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                        </div>
                        <div className="custom-shape" style={{ backgroundColor: layoutColor }} />
                    </div>
                </div>
            </Link>
        </>
    )
}

const GroupLayout = ({ layoutProps, card, group_id }) => {
    const { profilePicture, quantity, CardStylesofCard, userDetails } = layoutProps;

    return (
        <>
            <Link to={`/familyCard/${group_id}`}>
                <div className={`item-card-display digi-card-new  ${quantity === 1 ? "Smaller-screen" : ""}`}>
                    <Box className="preview-card all-cards">
                        <div id='Card-firstPart-createNew'>
                            <div className={`preview-card-upper-groupCard ${quantity === 1 ? "Smaller-screen" : ""}`}
                                style={{
                                    backgroundImage: `url(${profilePicture})`,
                                    backgroundSize: "cover", backgroundPosition: "center"
                                }}>
                                <div className={`digi-card-label-container truncate ${quantity === 1 ? "Smaller-screen" : ""}`} style={{ backgroundColor: CardStylesofCard?.colorLayout }}>
                                    <span className='digi-card-label'>{card}</span>
                                </div>
                                <div>
                                </div>
                            </div>

                            <div className={`preview-card-names text-start ${quantity === 1 ? "Smaller-screen" : ""}`}>
                                <h3 className='truncate' style={{ color: CardStylesofCard ? CardStylesofCard.colorPrimary : "black" }} title={userDetails.name}>{userDetails.name}</h3>
                            </div>
                        </div>
                    </Box>

                </div>
            </Link>
        </>
    )
}

export const AllCardLayouts = (layoutStyle, layoutProps, card, group_id) => {

    const { favoriteCards } = useUserDetailContext();
    // console.log("CARD Inside the ALLCARDLAYOUT", layoutProps);
    switch (layoutStyle) {
        case 'group':
            return <GroupLayout layoutProps={layoutProps} card={card} group_id={group_id} />;
        case '1':
            return <Layout1 layoutProps={layoutProps} card={card} favoriteCards={favoriteCards} />;
        case '3':
            return <Layout3 layoutProps={layoutProps} card={card} favoriteCards={favoriteCards} />;
        case '5':
            return <Layout5 layoutProps={layoutProps} card={card} favoriteCards={favoriteCards} />;
        case '7':
            return <Layout7 layoutProps={layoutProps} card={card} favoriteCards={favoriteCards} />;
        case '2':
            return <Layout2 layoutProps={layoutProps} card={card} favoriteCards={favoriteCards} />;
        case '4':
            return <Layout4 layoutProps={layoutProps} card={card} favoriteCards={favoriteCards} />;
        case '6':
            return <Layout6 layoutProps={layoutProps} card={card} favoriteCards={favoriteCards} />;
        case '8':
            return <Layout8 layoutProps={layoutProps} card={card} favoriteCards={favoriteCards} />;
        case 'ca1':
            return <LayoutCa1 layoutProps={layoutProps} card={card} />;
        case 'ca2':
            return <LayoutCa2 layoutProps={layoutProps} card={card} />;
        case 'hr1':
            return <LayoutHr1 layoutProps={layoutProps} card={card} />;
        case 'hr2':
            return <LayoutHr2 layoutProps={layoutProps} card={card} />;
        case 'bk1':
            return <LayoutBank1 layoutProps={layoutProps} card={card} />;
        case 'bk2':
            return <LayoutBank2 layoutProps={layoutProps} card={card} />;
        case 'fl1':
            return <LayoutFl1 layoutProps={layoutProps} card={card} />;
        case 'fl2':
            return <LayoutFl2 layoutProps={layoutProps} card={card} />;
        case 'cs1':
            return <LayoutCs1 layoutProps={layoutProps} card={card} />;
        case 'cs2':
            return <LayoutCs2 layoutProps={layoutProps} card={card} />;
        case 'it1':
            return <LayoutIt1 layoutProps={layoutProps} card={card} />;
        case 'it2':
            return <LayoutIt2 layoutProps={layoutProps} card={card} />;
        case 'adv1':
            return <LayoutAdv1 layoutProps={layoutProps} card={card} />;
        case 'adv2':
            return <LayoutAdv2 layoutProps={layoutProps} card={card} />;
        case 'dr1':
            return <LayoutDr1 layoutProps={layoutProps} card={card} />;
        case 'dr2':
            return <LayoutDr2 layoutProps={layoutProps} card={card} />;
        default:
            return <></>;
    }
};